export default "__VITE_ASSET__dwMyd7cj__"